import { AppPhase, DealingSubPhase, GameType } from '../../models/communication/app-enums.model';
import { AppEventType } from '../../models/communication/app-events.model';
import { YEventPayload } from '../../models/y-protocol.model';
import { ThreeHeadedDragonCardPosition, ThreeHeadedDragonOutcome } from '../main-games/three-headed-dragon/three-headed-dragon.model';

type Event = Omit<YEventPayload<AppEventType>, 'triggered'>;

export const configuration = {
    gameType: GameType.ThreeHeadedDragon,
    decisionTimeInSeconds: 400
};

export const demoEvents: Array<Event | Event[]> = [
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.DealingCards,
            subPhase: DealingSubPhase.Dealing
        }
    },

    {
        name: AppEventType.CardDealt,
        data: {
            card: 402,
            cardPosition: ThreeHeadedDragonCardPosition.GoldenDragonCard,
            tigerHandValue: 0,
            goldenDragonHandValue: 0,
            blackDragonHandValue: 0,
            redDragonHandValue: 0,
            nextCardPosition: ThreeHeadedDragonCardPosition.BlackDragonCard
        }
    },
    {
        name: AppEventType.CardDealt,
        data: {
            card: 310,
            cardPosition: ThreeHeadedDragonCardPosition.BlackDragonCard,
            tigerHandValue: 0,
            goldenDragonHandValue: 0,
            blackDragonHandValue: 0,
            redDragonHandValue: 0,
            nextCardPosition: ThreeHeadedDragonCardPosition.RedDragonCard
        }
    },
    {
        name: AppEventType.CardDealt,
        data: {
            card: 111,
            cardPosition: ThreeHeadedDragonCardPosition.RedDragonCard,
            tigerHandValue: 0,
            goldenDragonHandValue: 0,
            blackDragonHandValue: 0,
            redDragonHandValue: 0,
            nextCardPosition: ThreeHeadedDragonCardPosition.TigerCard
        }
    },

    [
        {
            name: AppEventType.CardDealt,
            data: {
                card: 0,
                cardPosition: ThreeHeadedDragonCardPosition.TigerCard,
                tigerHandValue: 0,
                goldenDragonHandValue: 0,
                blackDragonHandValue: 0,
                redDragonHandValue: 0
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.Decision
            }
        }
    ],

    [
        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.BetsClosed
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.DealingCards,
                subPhase: DealingSubPhase.Dealing
            }
        },

        {
            name: AppEventType.CardDealt,
            data: {
                card: 110,
                cardPosition: ThreeHeadedDragonCardPosition.TigerCard,
                tigerHandValue: 0,
                goldenDragonHandValue: 0,
                blackDragonHandValue: 0,
                redDragonHandValue: 0,
                outcome: ThreeHeadedDragonOutcome.DragonWin,
                outcomes: [ThreeHeadedDragonOutcome.TigerWin, ThreeHeadedDragonOutcome.Tie, ThreeHeadedDragonOutcome.DragonWin]
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.RoundEnd,
                outcome: ThreeHeadedDragonOutcome.DragonWin,
                outcomes: [ThreeHeadedDragonOutcome.TigerWin, ThreeHeadedDragonOutcome.TigerWin, ThreeHeadedDragonOutcome.DragonWin]
            }
        }
    ]
];
